import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { checkAccessFn } from "../../../../utils/checkAccess";
import useSearchPagination from "./../../../../ReusableComponents/SearchPagination/useSearchPagination";
import Highlighter from "react-highlight-words";

export default function ListDataRateCategory({
  list = [],
  editData,
  showCategoryItems,
  deleteData,
  loading,
  column = 5,
  titles = [],
}) {
  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    CountPerPage,
    Search,
    currentList,
  } = useSearchPagination(list?.data || []);

  const [searchWords, setSearchWords] = useState([]);
  return (
    <div className="pt-2 uppercase lg:w-11/12 ">
      <div className="flex md:flex-row flex-col  justify-between items-end">
        <Search searchKey={["name"]} setSearchWords={setSearchWords} />
        <p className="text-sm w-full text-right font-medium mb-1 xl:hidden block">{`Slide / scroll to right >`}</p>
        <CountPerPage />
      </div>
      <div
        className={`grid grid-cols-3 auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
      >
        {titles.map((title, index) => (
          <p key={index} className="font-semibold uppercase">
            {title}
          </p>
        ))}
        {list?.isLoading && (
          <div className="flex justify-center items-center gap-3 mt-5 w-full col-span-3">
            <p>Loading</p>
            <CgSpinner className="animate-spin" />
          </div>
        )}
        {!list?.isLoading && <NoDataFound />}

        {!list?.isLoading &&
          currentList?.map((l, index) => (
            <React.Fragment key={index}>
              <PaginationIndex index={index} />
              <p>
                <Highlighter
                  searchWords={searchWords}
                  autoEscape={true}
                  textToHighlight={l.name || "-"}
                />
              </p>

              {checkAccess("Rate Category", "rate-category-item-list") && (
                <Link to={`${l.id}?name=${l.name}`}>
                  <button
                    className="p-1 w-20 uppercase rounded-md ring-1 ring-slate-600"
                    onClick={() => showCategoryItems(l.id, l.name)}
                    disabled={
                      loading.edit || list?.isLoading || currentList.length <= 0
                    }
                  >
                    View
                  </button>
                </Link>
              )}
              {/* <div className="flex gap-3 min-w-fit ">
              <button
                className="p-1 w-20 rounded-md ring-1 ring-slate-600"
                onClick={() => editData(l.id)}
                disabled={loading.edit}
              >
                {loading.edit && loading.loadingId === l.id ? (
                  <CgSpinner className="animate-spin mx-auto" />
                ) : (
                  <CiEdit size={"1.4rem"} />

                )}
              </button>
              <button
                className="p-1 w-20 rounded-md ring-1 ring-red text-white bg-red"
                onClick={() =>
                  deleteData((oldState) => ({ open: true, id: l.id }))
                }
                disabled={loading.delete}
              >
                {loading.delete && loading.loadingId === l.id ? (
                  <CgSpinner className="animate-spin mx-auto" />
                ) : (
                  <MdDeleteOutline size={"1.4rem"} />


                )}
              </button>
            </div> */}
              <hr
                className={`border-[1.5px] border-slate-100  w-full col-span-3 `}
              />
            </React.Fragment>
          ))}
      </div>
      <Pagination />
    </div>
  );
}
